
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningRainShowersMon as ObiLightningRainShowersMonElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-rain-showers-mon.js';
 
 
 

 
 export const ObiLightningRainShowersMon = createComponent({
   react: React,
   tagName: 'obi-lightning-rain-showers-mon',
   elementClass: ObiLightningRainShowersMonElement,
   events: {
     
   }
  });
 
 